import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { CalendarGroupStoreModel } from '../../models/calendar-group.model';

@Injectable()
export class CalendarGroupStoreService {
  
  private baseUrl = HttpClientService.BASE_MS_COMMON + '/calendar-group-store';
  private baseUrlCommon = HttpClientService.BASE_MS_COMMON;

  
  private cachedFields: Observable<any>;  

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(id: number): Observable<CalendarGroupStoreModel> {
    return this.h.get(this.baseUrl + '/' + id);
  }

  delete(id: number) {
    return this.h.delete(this.baseUrl + '/' + id)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Confirmed', detail: 'Service deleted'});
      });
  }

  post(newData: CalendarGroupStoreModel) {
    return this.h.post(this.baseUrl + '/', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(data: CalendarGroupStoreModel) {
    return this.h.put(this.baseUrl + '/', data)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrlCommon + '/schema/CalendarGroupStoreDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calendar-group/calendar-group-store.service.ts